// The panel's open state lives in AiAgentLauncher and the request comes from
// entities/Intercom, so a window event is the smallest way to reach it.

const EVENT = 'webmcp:agent-panel-close'

export const requestCloseAgentPanel = (): void => {
  try {
    window.dispatchEvent(new Event(EVENT))
  } catch {
    // No window (non-browser test env) — nothing subscribes there.
  }
}

export const onCloseAgentPanelRequested = (callback: () => void): (() => void) => {
  window.addEventListener(EVENT, callback)
  return () => window.removeEventListener(EVENT, callback)
}
